<script lang="ts" setup>
import type { Section } from '~/types'

interface Props extends Pick<Section, 'title' | 'description'> {}
const props = defineProps<Props>()
</script>

<template>
  <div>
    <section class="w-full max-w-7xl mx-auto px-6 lg:px-12 pt-64">
      <HeadingText
        tag="h1"
        class=" text-blue max-w-md flex flex-col text-8xl xl:text-9xl !leading-[0.85em] font-display mb-6"
      >
        {{ title }}
      </HeadingText>
      <section
        class="htmldescription pb-12  max-w-4xl text-lg"
        data-allow-mismatch
        v-html="props.description"
      />
    </section>
  </div>
</template>
